export function resolveComplianceDocumentSectionsToGenerate(options: {
  fullDocument?: boolean
  sectionIds?: string[]
}): string[] | undefined {
  if (options.fullDocument === true) {
    return undefined
  }
  if (options.fullDocument === false) {
    if (options.sectionIds == null || options.sectionIds.length === 0) {
      return undefined
    }
    return options.sectionIds
  }
  return undefined
}
